<template>
  <app-main-layout>
    <!--  -->
    <!--  -->
    <template v-slot:left>
      <app-left-nav />
    </template>
    <!--  -->
    <template v-slot:bottom-nav>
      <app-bottom-nav />
    </template>
    <!--  -->
    <!--  -->
    <template v-slot:top>
      <app-top-nav padded>
        <template v-slot:left>
          <el-button
            v-if="false"
            type="text"
            plain
            circle
            is-all-borderless
            icon="el-icon-back"
          />
        </template>
        <template v-slot:center>
          <span nav-title>Matched Opportunities</span>
        </template>
        <template v-slot:right> </template>
        <template v-slot:bottom> </template>
      </app-top-nav>
    </template>
    <!--  -->
    <template v-slot:middle>
      <!--  -->
      <!-- Loaded Opportunities -->
      <div>
        <!--  -->
        <OpportunitiesList :opportunities="opportunities"></OpportunitiesList>
        <!--  -->
        <app-loader-opportunities
          :loading="loading"
          :resources="opportunities"
          content="Can't find matched opportunities."
        />
        <!--  -->
      </div>
    </template>
    <!--  -->
    <template v-slot:right>
      <app-right-nav>
        <app-user-right-intro />
      </app-right-nav>
    </template>
    <!--  -->
    <!--  -->
  </app-main-layout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import OpportunitiesList from "@/@business/views/opportunities-page/components/opportunities-list.component.vue";

@Options({
  components: { OpportunitiesList },
})
export default class extends Vue {
  /**
   * @returns created opportunities
   */
  get opportunities() {
    return this.$store.state.opportunities.opportunities;
  }

  /**
   * @returns the loading state of the created opportunities
   */
  get loading() {
    return this.$store.state.opportunities.loading;
  }

  mounted() {
    this.$store.dispatch("opportunities/fetch");
  }
}
</script>

<style lang="scss"></style>
